export class TemplateData {
    templateCompanyId: string;
    constructor(initialValues?: Partial<TemplateData>) {
        this.templateCompanyId = initialValues?.templateCompanyId ?? "";
    }
}
